import { render, staticRenderFns } from "./GetTagTypeModal.vue?vue&type=template&id=27eb2f0c"
import script from "./GetTagTypeModal.vue?vue&type=script&lang=js"
export * from "./GetTagTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports